import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { css } from 'emotion';
import { Form, Modal, Button, Toast } from '@douyinfe/semi-ui';
import { IconClose } from '@douyinfe/semi-icons';
import CopyToClipboard from 'react-copy-to-clipboard';
import './index.less';
import lineImg from '@/images/prize_line.png';
import closeIcon from '@/images/close_btn.png';
import closeEyeImg from '@/images/close_eye_pc.png';
import openEyeImg from '@/images/open_eye_pc.png';
export default function LotteryModal(props) {
  var submit = props.submit,
    prizeInfo = props.prizeInfo,
    closeModal = props.closeModal,
    locationMap = props.locationMap;
  var type = prizeInfo.type,
    name = prizeInfo.name,
    imgUrl = prizeInfo.imgUrl,
    cardId = prizeInfo.cardId,
    cardSecret = prizeInfo.cardSecret;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    infoModal = _useState2[0],
    setInfoModal = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showSecret = _useState4[0],
    setShowSecret = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    formApi = _useState6[0],
    setFormApi = _useState6[1];
  var writeInfo = function writeInfo() {
    setInfoModal(true);
  };
  var triggerSecret = function triggerSecret() {
    setShowSecret(!showSecret);
  };
  var getInfoUrl = function getInfoUrl() {
    var pathname = window.location.pathname.replace(/\/$/, '');
    var ret = pathname.split('/');
    if (!ret) return null;
    return "".concat(window.location.origin, "/").concat(ret[2], "/").concat(ret[3], "/").concat(ret[4], "/#/info");
  };
  var getFormApi = function getFormApi(api) {
    setFormApi(api);
  };
  var onSubmit = function onSubmit() {
    formApi.validate().then(function (formValues) {
      var params = _objectSpread({}, formValues);
      delete params.checkState;
      submit(params).then(function (res) {
        if (res && res.code === 200) {
          Toast.success({
            content: '地址提交成功',
            duration: 3
          });
          closeModal();
        }
      });
    }).catch(function (error) {
      console.log(error);
    });
  };
  var checkMobile = function checkMobile(rule, value) {
    if (value) {
      if (value.match(/^1\d{10}$/)) {
        return Promise.resolve();
      }
      return Promise.reject(new Error('请输入正确的手机号'));
    }
    return Promise.reject(new Error('请填写手机号'));
  };
  var checkState = function checkState(rule, value) {
    if (value) {
      return Promise.resolve();
    }
    return Promise.reject(new Error('请阅读并同意'));
  };
  var prizeCont = React.createElement(React.Fragment, null, React.createElement("div", {
    className: "prizeImgCont"
  }, React.createElement("img", {
    className: "prizeImg",
    src: imgUrl
  }), React.createElement("div", {
    className: "shadow"
  })), React.createElement("div", {
    className: prizeCls
  }, React.createElement("div", {
    className: "cardTop"
  }, React.createElement("div", {
    className: "winText"
  }, "\u606D\u559C\u4F60\u83B7\u5F97", name, "\uFF01"), React.createElement("div", {
    className: "underline"
  }, React.createElement("img", {
    src: lineImg
  }))), React.createElement("div", {
    className: "cardBottom"
  }, type === 1 && React.createElement("div", {
    className: "cont"
  }, React.createElement("div", {
    style: {
      marginBottom: 16
    }
  }, "\u5361\u53F7\uFF1A", cardId), React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center'
    }
  }, React.createElement("div", {
    style: {
      flex: 1
    }
  }, "\u5361\u5BC6\uFF1A", showSecret ? cardSecret : '**************************'), React.createElement("img", {
    style: {
      cursor: 'pointer',
      width: 20,
      marginLeft: 8
    },
    onClick: triggerSecret,
    src: showSecret ? openEyeImg : closeEyeImg
  }))), type === 2 && React.createElement("div", {
    className: "cont"
  }, React.createElement("p", {
    style: {
      marginBottom: 8
    }
  }, "\u4F7F\u7528\u8BF4\u660E\uFF1A"), React.createElement("p", {
    style: {
      marginBottom: 6
    }
  }, "1.\u67E5\u770B\u65B9\u5F0F\uFF08\u4EE5\u4E0B\u65B9\u5F0F\u5747\u53EF\u67E5\u770B\uFF09:"), React.createElement("p", {
    style: {
      marginLeft: 14,
      marginBottom: 4
    }
  }, "a. \u53F3\u4E0B\u89D2-\u6211\u7684\u94B1\u5305-\u5361\u5238\u4E2D\u67E5\u770B\uFF1B"), React.createElement("p", {
    style: {
      marginLeft: 14,
      marginBottom: 4
    }
  }, "b. \u5546\u57CE-\u5238/\u7EA2\u5305\u4E2D\u67E5\u770B\uFF1B"), React.createElement("p", {
    style: {
      marginTop: 6
    }
  }, "2.\u53EF\u5728\u8D2D\u7269\u65F6\u4F7F\u7528\u3002")), type === 0 && React.createElement("div", {
    className: "btn",
    onClick: writeInfo
  }, "\u586B\u5199\u5730\u5740"), type === 1 && React.createElement(CopyToClipboard, {
    text: "\u5361\u53F7\uFF1A".concat(cardId, ";\u5361\u5BC6\uFF1A").concat(cardSecret),
    onCopy: function onCopy() {
      Toast.success({
        content: '复制成功',
        duration: 3
      });
    }
  }, React.createElement("div", {
    className: "btn"
  }, "\u590D\u5236\u5361\u53F7\u5361\u5BC6")), React.createElement("div", {
    className: "tips"
  }, "\u8BF7\u622A\u56FE\u4FDD\u5B58\u54E6~"), React.createElement("div", {
    className: "close",
    onClick: closeModal
  }, React.createElement(IconClose, null)))));
  var userInfoCont = React.createElement(React.Fragment, null, React.createElement(Form, {
    className: formCls,
    getFormApi: getFormApi
  }, React.createElement(Form.Input, {
    field: "username",
    label: "\u59D3\u540D",
    showClear: true,
    autoComplete: "off",
    placeholder: "\u8BF7\u8F93\u5165\u59D3\u540D",
    rules: [{
      required: true,
      message: '请输入姓名'
    }]
  }), React.createElement(Form.Input, {
    field: "phone",
    label: "\u624B\u673A\u53F7\u7801",
    showClear: true,
    autoComplete: "off",
    placeholder: "\u8BF7\u8F93\u5165\u624B\u673A\u53F7\u7801",
    rules: [{
      validator: checkMobile
    }]
  }), React.createElement(Form.Cascader, {
    field: "location",
    label: "\u8BF7\u9009\u62E9\u6240\u5728\u5730\u533A",
    treeData: locationMap,
    placeholder: "\u8BF7\u9009\u62E9\u6240\u5728\u5730\u533A"
    // rules={[{ required: true, message: '请选择所在地区' }]}
  }), React.createElement(Form.Input, {
    field: "address",
    label: "\u8BE6\u7EC6\u5730\u5740",
    showClear: true,
    autoComplete: "off",
    placeholder: "\u8BF7\u586B\u5199\u8BE6\u7EC6\u5730\u5740",
    rules: [{
      required: true,
      message: '请填写详细地址'
    }]
  }), React.createElement("div", {
    className: "protocolCont"
  }, React.createElement(Form.Checkbox, {
    field: "checkState",
    noLabel: true,
    rules: [{
      validator: checkState
    }]
  }, "\u52FE\u9009\u6B64\u6846\u8868\u793A\u540C\u610F", React.createElement("span", {
    className: "statement",
    onClick: function onClick(e) {
      e.stopPropagation();
      var url = getInfoUrl();
      if (url) {
        window.open(url);
      }
    }
  }, "\u300A\u4E2A\u4EBA\u4FE1\u606F\u6388\u6743\u58F0\u660E\u300B")))));
  return React.createElement(React.Fragment, null, React.createElement(Modal, {
    title: '填写邮寄地址',
    onCancel: closeModal,
    maskClosable: false,
    visible: infoModal,
    footer: React.createElement(React.Fragment, null, React.createElement(Button, {
      type: "tertiary",
      onClick: closeModal
    }, "\u53D6\u6D88"), React.createElement(Button, {
      theme: "solid",
      type: "primary",
      onClick: onSubmit
    }, "\u63D0\u4EA4")),
    closable: true,
    centered: true,
    className: "infoModal"
  }, userInfoCont), React.createElement(Modal, {
    onCancel: closeModal,
    maskClosable: false,
    visible: !infoModal,
    footer: null,
    closable: false,
    centered: true,
    className: "prizeModal"
  }, prizeCont));
}
var prizeCls = /*#__PURE__*/css(".cardTop{.winText{margin-top:56px;margin-bottom:16px;text-align:center;font-weight:600;font-size:18px;color:#03081a;}.underline{position:relative;padding:0 16px;height:16px;line-height:16px;overflow:hidden;img{width:calc(100% - 48px);position:absolute;left:24px;top:50%;transform:translateY(-50%);}&::before,&::after{content:'';width:16px;height:16px;position:absolute;top:0;border-radius:50%;background:rgba(22,22,26,0.6);}&::before{left:-8px;}&::after{right:-8px;}}}.cardBottom{padding:16px 24px 40px;color:#03081a;font-size:14px;.cont{padding:0 20px;margin-bottom:24px;font-size:14px;font-weight:400;color:#1c1f23;}.btn{margin:16px 0 24px;padding:12px 0;text-align:center;background:#0064fa;border-radius:8px;color:#fff;font-weight:600;cursor:pointer;}.tips{color:#fe2c55;text-align:center;font-size:14px;}.close{width:28px;height:28px;position:absolute;left:50%;margin-left:-12px;bottom:-52px;text-align:center;line-height:36px;background:rgba(41,41,41,0.34);border-radius:50%;cursor:pointer;.semi-icon-default{font-size:18px;color:#fff;}}}");
var formCls = /*#__PURE__*/css(".protocolCont{display:flex;align-items:center;font-size:14px;.statement{display:inline-block;color:#007ffa;cursor:pointer;}}.semi-cascader{width:100%;}.semi-form-field-label-required .semi-form-field-label-text::after{content:'';}");